export default __webpack_public_path__ + "static/media/2_0082.31708453.webp";